import { useEffect } from "react";

const useTabs = ({ modalId, onClose }) => {
	useEffect(() => {
		const modalEl = document.getElementById(modalId);
		if (!modalEl) return undefined;

		const handleHide = () => {
			try {
				if (window.getSelection) {
					const selection = window.getSelection();
					if (selection && selection.removeAllRanges) {
						selection.removeAllRanges();
					}
				}
			} catch (err) {
				// noop
			}

			try {
				if (document.activeElement && document.activeElement.blur) {
					document.activeElement.blur();
				}
			} catch (err) {
				// noop
			}

			if (typeof onClose === "function") {
				onClose();
			}
		};

		modalEl.addEventListener("hidden.bs.modal", handleHide);
		return () => modalEl.removeEventListener("hidden.bs.modal", handleHide);
	}, [modalId, onClose]);

	useEffect(() => {
		const modalEl = document.getElementById(modalId);
		if (!modalEl) return undefined;

		const handleShow = () => {
			modalEl
				.querySelectorAll(".nav-link")
				.forEach((el) => el.classList.remove("active"));

			modalEl
				.querySelectorAll(".tab-pane")
				.forEach((el) => el.classList.remove("show", "active"));

			const firstLink = modalEl.querySelector(".nav-link");
			const firstPane = modalEl.querySelector(".tab-pane");

			if (firstLink) firstLink.classList.add("active");
			if (firstPane) firstPane.classList.add("show", "active");
		};

		modalEl.addEventListener("show.bs.modal", handleShow);
		return () => modalEl.removeEventListener("show.bs.modal", handleShow);
	}, [modalId]);
};

export default useTabs;
